import { createFileRoute } from '@tanstack/react-router';
import { SignIn } from '@/components';

export const Route = createFileRoute('/_layout/signin')({
  component: SignIn
});
